import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT } from '../data/constants';
export function Guarantee() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-72" data-mp="1o33u6h0ytshr">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 px-4 text-center sm:flex-row sm:gap-5 sm:px-6 sm:text-left" data-id="element-73" data-mp="22369bvhw27tb">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-white sm:h-24 sm:w-24" data-id="element-74" data-mp="1x5d5h9425pw7">
          <ShieldCheckIcon className="h-7 w-7 text-tech-light sm:h-8 sm:w-8" strokeWidth={2} aria-hidden="true" data-id="element-75" data-mp="14fo3otjixltj" />
          <span className="mt-0.5 font-display text-xs font-extrabold uppercase leading-none" data-id="element-76" data-mp="1j52c9zf9zz7v">
            7 jours
          </span>
        </div>
        <div data-id="element-77" data-mp="1ec99vi7a52yy">
          <h2 className="text-xl leading-tight text-navy sm:text-3xl" data-id="element-78" data-mp="1ebr1jn7ceyao">
            SATISFAIT <span className="text-tech" data-id="element-79" data-mp="qmooksnnltmi">OU REMBOURSÉ PENDANT 7 JOURS</span>
          </h2>
          <p className="mt-1.5 text-sm leading-snug text-steel sm:text-base" data-id="element-80" data-mp="lodeqhxczj4a">
            Explorez {PRODUCT} pendant 7 jours. Découvrez les six modules, les fiches de
            diagnostic, les arbres de décision, les checklists atelier, les cas pratiques et les
            cinq bonus. Si le système ne vous convient pas, contactez-nous dans les 7 jours pour
            obtenir un remboursement complet selon les conditions de remboursement.
          </p>
        </div>
      </div>
    </section>;
}